import Separator from './separator';

export { type SeparatorProps } from './separator';
export default Separator;
